import React from 'react';
import {ComponentFrame} from "../../frame/ComponentFrame";
import {SectionHeader} from "../section-header/SectionHeader";
import {Container} from 'reactstrap';
import {ApplicationForm} from "../../forms/ApplicationForm";

export class WorkWithUs extends React.Component {

  render(){
    return (
      <ComponentFrame tag="section"
                      color="#EEF1F4"
                      style={{ position: 'relative' }}
                      header={
                        <SectionHeader align="center"
                                       color="#EEF1F4"
                                       title="Interested in Working With Us?" />
                      }>
        <Container className="contact-workwithus-container">
          <div className="contact-workwithus-desc">We are always looking for new tallented people. Drop us a line and we get back to you.</div>
          <ApplicationForm/>
        </Container>
      </ComponentFrame>
    );
  }
}






// WEBPACK FOOTER //
// ./src/components/contact-us/WorkWithUs.js